export function formatNumber(value: Number, places: number = 2): Number {
  try {
    return Number(Number(value).toFixed(places));
  } catch {
    return Number(0.0);
  }
}